export default __webpack_public_path__ + "images/GoSomewhere.v-8522af2e2bbcc908bbaea8d4c63254fd.svg";